import getOptimizelyInstance from './getOptimizelyInstance';
let userIdCache;
export const setUserId = newUserId => {
  userIdCache = newUserId;
};

/**
 * Deprecated. Instead of this module, please import the `useOptimizelyTrack` hook to get proper context sensitivity:
 * `const optimizelyTrack = useOptimizelyTrack()`
 */
const optimizelyTrack = function (eventKey, _temp) {
  let {
    userId = userIdCache,
    attributes,
    tags,
    value = tags && tags.value
  } = _temp === void 0 ? {} : _temp;
  return getOptimizelyInstance().track(eventKey, userId, attributes, {
    ...tags,
    value
  });
};
export default optimizelyTrack;